import ChargeHelper from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddVehicleView from '../DialogAddVehicleView';
import ChargeVehicleListFilterView from './components/ChargeVehicleListFilterView';
import AppConstants from 'general/constants/AppConstants';

ChargeVehicleListView.propTypes = {};

const defaultColumnIds = [
  'LOGO',
  'PLATE',
  'DRIVER',
  'STATUS',
  'VEHICLE_TYPE',
  'VEHICLE_BRAND',
  'VEHICLE_MODEL',
  'VIN_NUMBER',
  'ID_TAG'
];

function ChargeVehicleListView(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user, permissionList } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeVehicleList);
  const [chargeVehicleList, setChargeVehicleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    const params = _.pickBy(
      filter,
      (value) => value !== null && value !== undefined && value !== ''
    );
    ChargeHelper.API.Vehicle.requestGetVehicleList(params)
      .then((response) => {
        setChargeVehicleList(response?.vehicles);
        setTotal(response?.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'LOGO',
        name: UIHelper.buildTableColumn('Ảnh xe'),
        selector: (row) =>
          UIHelper.buildAvatar(
            row?.model?.image ? Utils.getFullUrl(row?.model?.image) : null,
            40,
            AppResource.images.chargeConnectorTypes.vehicleDefault,
            false,
            false
          ),
        width: '70px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số'),
        selector: (row) => row?.plate,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'DRIVER',
        name: UIHelper.buildTableColumn('Tên khách hàng'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.customerList}/${row?.userId}`);
            }}
          >
            {row?.user?.fullname}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái'),
        selector: (row) => {
          return (
            <KTLabel
              text={ChargeHelper.Utils.getVehicleStatusName(row?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${ChargeHelper.Utils.getVehicleStatusColor(
                row?.status
              )}`}
            />
          );
        },
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_TYPE',
        name: UIHelper.buildTableColumn('Loại phương tiện'),
        selector: (row) =>
          row?.vehicleType
            ? _.find(
              ChargeHelper.Data.vehicleTypeOptions,
              (item) => item.value === row?.vehicleType
            )?.name
            : '',
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_BRAND',
        name: UIHelper.buildTableColumn('Hãng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.model?.brandId}`);
            }}
          >
            {row?.model?.brand?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VEHICLE_MODEL',
        name: UIHelper.buildTableColumn('Dòng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.model?.brandId}`);
            }}
          >
            {row?.model?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VIN_NUMBER',
        name: UIHelper.buildTableColumn('Số khung'),
        selector: (row) => row?.vinNumber,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ID_TAG',
        name: UIHelper.buildTableColumn('Mã ID Tag'),
        selector: (row) => {
          const activeCard = row?.cards?.find(card => card?.status === 'NORMAL');
          return (
            <div> {activeCard?.idTag}</div>
          )
        },
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, [user]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const windowSize = useWindowSize();
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
    saveChanges,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);
  const [selectedVehicleBrand, setSelectedVehicleBrand] = useState(null);
  const [selectedVehicleModel, setSelectedVehicleModel] = useState(null);
  const [defaultDropdownVehicleModel, setDefaultDropdownVehicleModel] = useState(null);
  useEffect(() => {
    setDefaultDropdownVehicleModel({
      name: 'Dòng xe',
      role: 'VEHICLE_MODEL',
      brandId: selectedVehicleBrand?.id,
    });
  }, [selectedVehicleBrand]);
  const dropdownVehicleBrandEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="brandId"
        name="brandId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedVehicleBrand?.name ?? 'Chọn hãng xe'}
          </button>
        }
        selectedValue={selectedVehicleBrand}
        dropdownMenuItems={[{ name: 'Hãng xe', role: 'VEHICLE_BRAND' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.brands?.map((row) => ({
                id: row?.brandId,
                name: row?.name,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleBrand(value);
          setSelectedVehicleModel(null);
          ChargeHelper.Filter.chargeVehicleList = {
            ...ChargeHelper.Filter.chargeVehicleList,
            brandId: value?.id,
            page: 0,
          };
          handleRefresh();
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Hãng xe',
          role: 'VEHICLE_BRAND',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleBrand(null);
              setSelectedVehicleModel(null);
              ChargeHelper.Filter.chargeVehicleList = {
                ...ChargeHelper.Filter.chargeVehicleList,
                brandId: '',
                modelId: '',
                page: 0,
              };
              handleRefresh();
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand]);
  const dropdownVehicleModelEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="modelId"
        name="modelId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedVehicleBrand ? 'disabled' : ''
              }`}
            type="button"
          >
            {selectedVehicleModel?.name ?? 'Chọn dòng xe'}
          </button>
        }
        selectedValue={selectedVehicleModel}
        dropdownMenuItems={[{ name: 'Dòng xe', role: 'VEHICLE_MODEL' }]}
        getSubItems={async (item) => {
          if (Utils.isValid(selectedVehicleBrand?.id))
            return ChargeHelper.API.VehicleModel.requestGetVehicleModelList(
              selectedVehicleBrand?.id,
              {
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              }
            ).then((data) => {
              return {
                values: data.models?.map((row) => ({
                  id: row?.modelId,
                  name: row?.name,
                  item: row,
                })),
                total: data.total,
              };
            });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleModel(value);
          ChargeHelper.Filter.chargeVehicleList = {
            ...ChargeHelper.Filter.chargeVehicleList,
            modelId: value?.id,
            page: 0,
          };
          handleRefresh();
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        disabled={!selectedVehicleBrand}
        defaultValue={defaultDropdownVehicleModel}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleModel(null);
              ChargeHelper.Filter.chargeVehicleList = {
                ...ChargeHelper.Filter.chargeVehicleList,
                modelId: '',
                page: 0,
              };
              handleRefresh();
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand, selectedVehicleModel, defaultDropdownVehicleModel]);
  useEffect(() => {
    const brandId = ChargeHelper.Filter.chargeVehicleList?.brandId;
    if (brandId) {
      ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({ brandId }).then((data) => {
        if (data.brands?.length > 0) {
          setSelectedVehicleBrand({
            id: data.brands[0].brandId,
            name: data.brands[0].name,
          });
        }
      });

      const modelId = ChargeHelper.Filter.chargeVehicleList?.modelId;
      if (modelId) {
        ChargeHelper.API.VehicleModel.requestGetVehicleModelList(brandId, { modelId }).then(
          (data) => {
            if (data.models?.length > 0) {
              setSelectedVehicleModel({
                id: data.models[0].modelId,
                name: data.models[0].name,
              });
            }
          }
        );
      }
    }
  }, []);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    // xem chi tiet
    if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleView.code)) {
      actions.push({
        text: 'Xem chi tiết',
        iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          router.navigate(`${row?.vehicleId}`);
        },
      });
    }
    if (isAdmin) {
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleUpdate.code)) {
        // chinh sua
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleAddNew(row);
          },
        });
      }
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleDelete.code)) {
        // xoa
        actions.push({
          text: 'Xoá',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleDelete(row);
          },
        });
      }
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeVehicleList });
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.Vehicle.showDialogConfirmDeleteVehicle(row, () => {
      handleRefresh();
    });
  };
  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa xe' : 'Thêm xe',
      <DialogAddVehicleView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'lg',
      false,
      true
    );
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
            {/* title */}
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Danh sách xe
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} xe
                </span>
              </span>
            </div>

            {/* actions */}
            {isAdmin && Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleCreate.code) &&
              UIHelper.buildGreenButton(
                'Thêm mới',
                handleAddNew,
                <i className="fa-regular fa-circle-plus" />
              )}
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="row m-0 p-0 px-2">
              {/* tim kiem */}
              {windowSize.width >= 768 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo biển số xe, số khung..."
                    value={filter.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeVehicleList = {
                        ...ChargeHelper.Filter.chargeVehicleList,
                        q: text,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              )}
              {/* loc theo loai xe */}
              {windowSize.width >= 1120 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Loại xe')}
                  <KTBSDropdown
                    name="vehicleType"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {_.find(
                          ChargeHelper.Data.vehicleTypeOptions,
                          (item) =>
                            item.value === ChargeHelper.Filter.chargeVehicleList?.vehicleType
                        )?.name ?? 'Tất cả'}
                      </button>
                    }
                    selectedValue={ChargeHelper.Filter.chargeVehicleList?.vehicleType}
                    dropdownMenuItems={[
                      { name: 'Tất cả', value: '' },
                      ...ChargeHelper.Data.vehicleTypeOptions,
                    ]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      ChargeHelper.Filter.chargeVehicleList = {
                        ...ChargeHelper.Filter.chargeVehicleList,
                        vehicleType: value,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}
              {/* loc theo hang xe */}
              {windowSize.width >= 1368 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Hãng xe')}
                  {dropdownVehicleBrandEl}
                </div>
              )}
              {/* loc theo dong xe */}
              {windowSize.width >= 1616 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Dòng xe')}
                  {dropdownVehicleModelEl}
                </div>
              )}
              {/* thiet lap cot */}
              <div className="col mb-4 px-2 d-flex align-items-end gap-3">
                {/* bo loc */}
                <ButtonFilterDropdown
                  dropdownContent={
                    <ChargeVehicleListFilterView
                      onCancel={() => {
                        handleRefresh();
                      }}
                      onApply={() => {
                        handleRefresh();
                      }}
                      initialSelectedBrand={selectedVehicleBrand}
                      initialSelectedModel={selectedVehicleModel}
                      onSelectedBrandChange={(value) => {
                        setSelectedVehicleBrand(value);
                      }}
                      onSelectedModelChange={(value) => {
                        setSelectedVehicleModel(value);
                      }}
                    />
                  }
                />
                <DropdownTableConfigColumn
                  columnIds={columnIds}
                  fullColumns={fullColumns}
                  fullColumnIds={fullColumnsIdSorted}
                  onChangeCheckboxValue={onChangeCheckboxValue}
                  resetDefaultTableColumn={resetDefaultTableColumn}
                  onChangeFullColumnIds={(ids) => {
                    setFullColumnIds(ids);
                    const key = prefKey + '_FULL_COLUMN_IDS';
                    localStorage.setItem(key, ids.join('|'));
                  }}
                  onSelectAll={onSelectAll}
                  onUnSelectAll={onUnSelectAll}
                  saveChanges={saveChanges}
                />
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={columns}
                items={chargeVehicleList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                  'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                )}
              />
            </div>
          </div>

          {/* pagination */}
          <div className="px-4 mt-2">
            <KTPagination
              currentPage={filter.page + 1}
              rowCount={total}
              rowsPerPage={filter.limit}
              currentItemInPageCount={chargeVehicleList?.length}
              onChangePage={(newPage) => {
                const iNewPage = parseInt(newPage);
                ChargeHelper.Filter.chargeVehicleList = {
                  ...ChargeHelper.Filter.chargeVehicleList,
                  page: iNewPage - 1,
                };
                handleRefresh();
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                const iNewRowsPerPage = parseInt(newRowsPerPage);
                ChargeHelper.Filter.chargeVehicleList = {
                  ...ChargeHelper.Filter.chargeVehicleList,
                  limit: iNewRowsPerPage,
                  page: 0,
                };
                handleRefresh();
              }}
              loading={false}
              color={KTPaginationColor.success}
              appendText="xe"
            />
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeVehicleListView;
